module.exports = __webpack_public_path__ + "img/gray.b1f3886.svg";